import { render, staticRenderFns } from "./cooperationDetail.vue?vue&type=template&id=07d24a52&scoped=true"
import script from "./cooperationDetail.vue?vue&type=script&lang=js"
export * from "./cooperationDetail.vue?vue&type=script&lang=js"
import style0 from "./cooperationDetail.vue?vue&type=style&index=0&id=07d24a52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d24a52",
  null
  
)

export default component.exports